import React, { useEffect, useState } from "react";
import { Container, Row, Col, Breadcrumb, BreadcrumbItem, Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import { Home } from "react-feather";
import Select from "react-select";
import moment from "moment";
import axios from "axios";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import { KIBANA_PLM_URL, KIBANA_PLM_INTERNAL_URL } from "../../Common/KibanaAPIEndpoints/KibanaAPIEndpoints";

import { useKibanaAuthentication } from "../../hooks/useKibanaAuthentication";

export default function SystemWideResqueJobs() {

  const {setToken} = useKibanaAuthentication();

  const [loading, setLoading] = useState(true)

  const search = useLocation().search;
  const commit = new URLSearchParams(search).get("commit");
  const tabNameFromSearchUrl = new URLSearchParams(search).get("filter[tab_name]");
  const tabNameFromUrl = window.location.hash.substr(1);
  const searchParams = {
    geoCluster: new URLSearchParams(search).get("filter[geo_cluster]"),
    jobType: new URLSearchParams(search).get("filter[job_type]"),
    clusterName: new URLSearchParams(search).get("filter[cluster_name]"),
    fromTime: new URLSearchParams(search).get("filter[time]") == 'now/d' ? 'now%2Fd' : new URLSearchParams(search).get("filter[time]"),
    tabName: tabNameFromSearchUrl ? tabNameFromSearchUrl : tabNameFromUrl
  }
  const [geoCluster, setGeoCluster] = useState({ label: 'All', value: '*' });
  const [geoClusterOptions, setGeoClusterOptions] = useState([]);
  const [jobType, setJobType] = useState({ label: 'All', value: '*' });
  const [clusterName, setClusterName] = useState({ label: 'All', value: '*' });
  const [fromTime, setFromTime] = useState({ label: 'Today', value: 'now%2Fd' });
  const [activeTab, setActiveTab] = useState(tabNameFromUrl ? tabNameFromUrl : 'recrawl');

  const jobTypeOptions = [
    { label: 'All', value: '*' },
    { label: 'Recrawl', value: 'recrawl' },
    { label: 'Distributed Recrawl', value: 'distributed_recrawl' },
    { label: 'Feedcrawl', value: 'feedcrawl3' },
    { label: 'Dependent Data Upload', value: 'dependent_data_upload' },
    { label: 'Total Running And Waiting Jobs', value: 'total_running_and_waiting_jobs' },
  ]

  const clusterNameOptions = [
    { label: 'All', value: '*' },
    { label: 'cluster1', value: 'cluster1' },
    { label: 'cluster2', value: 'cluster2' },
  ]

  const timeOptions = [
    { label: 'Today', value: 'now%2Fd' },
    { label: 'Last 30 minutes', value: 'now-30m' },
    { label: 'Last 1 hour', value: 'now-1h' },
    { label: 'Last 2 hours', value: 'now-2h' },
    { label: 'Last 4 hours', value: 'now-4h' },
    { label: "Last 10 hours", value: "now-10h" },
    { label: 'Last 12 hours', value: 'now-12h' },
    { label: 'Last 24 hours', value: 'now-24h' },
    { label: 'Last 2 days', value: 'now-2d' },
    { label: 'Last 3 days', value: 'now-3d' },
    { label: 'Last 4 days', value: 'now-4d' },
    { label: 'Last 7 days', value: 'now-7d' },
    { label: 'Last 15 days', value: 'now-15d' },
    { label: 'Last 30 days', value: 'now-30d' },
    { label: 'Last 60 days', value: 'now-60d' },
    { label: 'Last 1 year', value: 'now-1y' }
  ];

  const [UrlParams, setUrlParams] = useState({
    geoCluster: "*",
    jobType: '*',
    clusterName: '*',
    fromTime: 'now%2Fd',
    tabName: "recrawl"
  })

  useEffect(() => {
    setSearchParamsData();
    async function fetchInitialData() {
      try {
        setLoading(true);
        await setToken(KIBANA_PLM_URL)
        const res = await axios.get('/api/v1/internal/dropdown_list_helper')
        let geo_clusters = []
        res.data.geo_clusters.forEach(item => {
          geo_clusters.push({ label: item, value: item })
        })
        geo_clusters.push({ label: 'All', value: '*' })
        setGeoClusterOptions(geo_clusters);

      } catch (err) {
        console.error("Failed to fetch data", err);
      } finally {
        setLoading(false);
      }
    }

    fetchInitialData();
  }, []);

  function setSearchParamsData() {
    if (searchParams.geoCluster && searchParams.geoCluster != geoCluster.value) {
      setGeoCluster({ label: searchParams.geoCluster == '*' ? 'All' : searchParams.geoCluster, value: searchParams.geoCluster });
    }
    if (searchParams.jobType && searchParams.jobType != jobType.value) {
      setJobType(jobTypeOptions.filter(option => option.value == searchParams.jobType)[0]);
    }
    if (searchParams.clusterName && searchParams.clusterName != clusterName.value) {
      setClusterName(clusterNameOptions.filter(option => option.value == searchParams.clusterName)[0]);
    }
    if (searchParams.fromTime && searchParams.fromTime != fromTime.value) {
      setFromTime( timeOptions.filter(item => item.value == searchParams.fromTime)[0]);
    }
    if (searchParams.tabName && searchParams.tabName != activeTab) {
      setActiveTab(searchParams.tabName == '*' ? 'recrawl' : searchParams.tabName);
    }
    if (commit == 'Get Data' && searchParams.fromTime && searchParams.geoCluster && searchParams.jobType && searchParams.clusterName) {
      setUrlParams(searchParams)
    }
  }

  function recrawlKibanaUrl(kibana_url) {
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:'${UrlParams.fromTime}',mode:quick,to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:(query_string:(analyze_wildcard:!t,query:'file_name:%22resque_utils.rb%22++AND+%22resque_jobs_tracker%22+AND+job_type:%22recrawl%22+AND+geo_cluster:${UrlParams.geoCluster}+AND+cluster:${cluster_name_val}'))),uiState:(vis:(colors:(waiting:%23BA43A9))),vis:(aggs:!((id:'1',params:(customLabel:job_count,field:job_count),schema:metric,type:sum),(id:'2',params:(customInterval:'0.5h',extended_bounds:(),field:'@timestamp',interval:custom,min_doc_count:1),schema:segment,type:date_histogram),(id:'4',params:(field:current_status.raw,order:desc,orderBy:'1',size:5),schema:group,type:terms)),listeners:(),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,defaultYExtents:!f,drawLinesBetweenPoints:!t,interpolate:linear,radiusRatio:9,scale:linear,setYExtents:!f,shareYAxis:!t,showCircles:!t,smoothLines:!f,times:!(),yAxis:()),title:'System+Wide+Resque+Graph+-+Recrawl',type:line))`
  }

  function distributedRecrawlKibanaUrl(kibana_url) {
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:'${UrlParams.fromTime}',mode:quick,to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:(query_string:(analyze_wildcard:!t,query:'file_name:%22resque_utils.rb%22++AND+%22resque_jobs_tracker%22+AND+job_type:%22distributed_recrawl%22+AND+geo_cluster:${UrlParams.geoCluster}+AND+cluster:${cluster_name_val}'))),uiState:(vis:(colors:(waiting:%23BA43A9))),vis:(aggs:!((id:'1',params:(customLabel:job_count,field:job_count),schema:metric,type:sum),(id:'2',params:(customInterval:'0.5h',extended_bounds:(),field:'@timestamp',interval:custom,min_doc_count:1),schema:segment,type:date_histogram),(id:'4',params:(field:current_status.raw,order:desc,orderBy:'1',size:5),schema:group,type:terms)),listeners:(),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,defaultYExtents:!f,drawLinesBetweenPoints:!t,interpolate:linear,radiusRatio:9,scale:linear,setYExtents:!f,shareYAxis:!t,showCircles:!t,smoothLines:!f,times:!(),yAxis:()),title:'System+Wide+Resque+Graph+-+Distributed+Recrawl',type:line))`
  }

  function feedcrawlKibanaUrl(kibana_url) {
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:'${UrlParams.fromTime}',mode:quick,to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:(query_string:(analyze_wildcard:!t,query:'file_name:%22resque_utils.rb%22++AND+%22resque_jobs_tracker%22+AND+job_type:%22feedcrawl3%22+AND+geo_cluster:${UrlParams.geoCluster}+AND+cluster:${cluster_name_val}'))),uiState:(vis:(colors:(waiting:%23BA43A9))),vis:(aggs:!((id:'1',params:(customLabel:job_count,field:job_count),schema:metric,type:sum),(id:'2',params:(customInterval:'0.5h',extended_bounds:(),field:'@timestamp',interval:custom,min_doc_count:1),schema:segment,type:date_histogram),(id:'4',params:(field:current_status.raw,order:desc,orderBy:'1',size:5),schema:group,type:terms)),listeners:(),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,defaultYExtents:!f,drawLinesBetweenPoints:!t,interpolate:linear,radiusRatio:9,scale:linear,setYExtents:!f,shareYAxis:!t,showCircles:!t,smoothLines:!f,times:!(),yAxis:()),title:'System+Wide+Resque+Graph+-+Feedcrawl',type:line))`
  }

  function dependentDataUploadKibanaUrl(kibana_url) {
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:'${UrlParams.fromTime}',mode:quick,to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:(query_string:(analyze_wildcard:!t,query:'file_name:%22resque_utils.rb%22++AND+%22resque_jobs_tracker%22+AND+job_type:%22dependent_data_upload%22+AND+geo_cluster:${UrlParams.geoCluster}+AND+cluster:${cluster_name_val}'))),uiState:(vis:(colors:(running:%23CCA300,waiting:%23BA43A9))),vis:(aggs:!((id:'1',params:(customLabel:job_count,field:job_count),schema:metric,type:sum),(id:'2',params:(customInterval:'0.5h',extended_bounds:(),field:'@timestamp',interval:custom,min_doc_count:1),schema:segment,type:date_histogram),(id:'4',params:(field:current_status.raw,order:desc,orderBy:'1',size:5),schema:group,type:terms)),listeners:(),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,defaultYExtents:!f,drawLinesBetweenPoints:!t,interpolate:linear,radiusRatio:9,scale:linear,setYExtents:!f,shareYAxis:!t,showCircles:!t,smoothLines:!f,times:!(),yAxis:()),title:'System+Wide+Resque+Graph+-+Dependent+Data+Upload',type:line))`
  }

  function totalRunningAndWaitingJobsKibanaUrl(kibana_url) {
    var to_time_val = UrlParams.fromTime == "now%2Fd" ? "now%2Fd" : "now";
    var cluster_name_val = UrlParams.clusterName == "All" ? "*" : UrlParams.clusterName;

    return `${kibana_url}app/kibana#/visualize/create?type=line&indexPattern=76972760-1ad0-11ec-9735-177ab3888d9e&_g=(refreshInterval:(display:Off,pause:!f,value:0),time:(from:'${UrlParams.fromTime}',mode:quick,to:'${to_time_val}'))&_a=(filters:!(),linked:!f,query:(language:lucene,query:(query_string:(analyze_wildcard:!t,query:'file_name:%22resque_utils.rb%22++AND+%22resque_jobs_tracker%22+AND+geo_cluster:${UrlParams.geoCluster}+AND+cluster:${cluster_name_val}'))),uiState:(vis:(colors:(waiting:%23BA43A9))),vis:(aggs:!((id:'1',params:(customLabel:job_count,field:job_count),schema:metric,type:sum),(id:'2',params:(customInterval:'0.5h',extended_bounds:(),field:'@timestamp',interval:custom,min_doc_count:1),schema:segment,type:date_histogram),(id:'4',params:(field:current_status.raw,order:desc,orderBy:'1',size:5),schema:group,type:terms)),listeners:(),params:(addLegend:!t,addTimeMarker:!f,addTooltip:!t,defaultYExtents:!f,drawLinesBetweenPoints:!t,interpolate:linear,radiusRatio:9,scale:linear,setYExtents:!f,shareYAxis:!t,showCircles:!t,smoothLines:!f,times:!(),yAxis:()),title:'System+Wide+Resque+Graph+-+Total+running+and+waiting+workers',type:line))`
  }

  const handleGetData = () => {
    window.location.href = `/internal/resque_info/system_wide_resque_jobs?filter[geo_cluster]=${geoCluster.value}&filter[job_type]=${jobType.value}&filter[cluster_name]=${clusterName.value}&filter[time]=${fromTime.value}&filter[tab_name]=${jobType.value == 'feedcrawl3' ? 'feedcrawl' : jobType.value}&commit=${'Get Data'}`
  }

  if(loading) {
    return (
      <Loader type="Puff" color="#00BFFF" height={100} width={100} className='pc-loader' />
    )
  }

  return <Container fluid>
    <div className="page-title">
      <Row className=''>
        <Col xs="6">
          <h3>Internal Dashboard</h3>
        </Col>
        <Col xs="6">
          <Breadcrumb>
            <BreadcrumbItem>
              <Link to={'/internal'}>
                <Home />
              </Link>
            </BreadcrumbItem>
            <BreadcrumbItem>
              {commit == 'Get Data' ? <a href="/internal/resque_info/system_wide_resque_jobs">System Wide Resque Jobs</a> : 'System Wide Resque Jobs'}
            </BreadcrumbItem>
            {commit == 'Get Data' && <BreadcrumbItem className="fw-bold">
              Search
            </BreadcrumbItem>}
          </Breadcrumb>
        </Col>
      </Row>
    </div>

    <Card>
      <CardBody>
        <Row>
          <Col sm="3">
            <label className="fw-bold">Geo Cluster</label>
            <Select
              value={geoCluster}
              options={geoClusterOptions}
              onChange={option => setGeoCluster(option)} />
          </Col>
          <Col sm="3">
            <label className="fw-bold">Time</label>
            <Select
              value={fromTime}
              options={timeOptions}
              onChange={option => setFromTime(option)} />
          </Col>
          <Col sm="3">
            <label className="fw-bold">Job Type</label>
            <Select
              value={jobType}
              options={jobTypeOptions}
              onChange={option => setJobType(option)} />
          </Col>
          <Col sm="3">
            <label className="fw-bold">Choose Cluster</label>
            <Select
              value={clusterName}
              options={clusterNameOptions}
              onChange={option => setClusterName(option)} />
          </Col>
        </Row>
        <Row className="align-items-end mt-4">
          <Col sm="4">
            <button className="btn btn-success w-100" onClick={handleGetData}>Get Data</button>
          </Col>
        </Row>
      </CardBody>
    </Card>
    <Card>
      <CardBody>
        <div className="mb-1">
          <b>NOTE:</b>
          If the graph is not shown after your form submission then you should do either maximize its size(the option is available on the right side of graph) or minimize the sidebar.
        </div>
        <Nav tabs>
          <NavItem>
            <NavLink className={activeTab == 'recrawl' ? 'active' : ''} onClick={() => setActiveTab('recrawl')}>
              Recrawl
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'distributed_recrawl' ? 'active' : ''} onClick={() => setActiveTab('distributed_recrawl')}>
              Distributed Recrawl
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'feedcrawl' ? 'active' : ''} onClick={() => setActiveTab('feedcrawl')}>
              Feedcrawl
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'dependent_data_upload' ? 'active' : ''} onClick={() => setActiveTab('dependent_data_upload')}>
              Dependent Data Upload
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink className={activeTab == 'total_running_and_waiting_jobs' ? 'active' : ''} onClick={() => setActiveTab('total_running_and_waiting_jobs')}>
              Total Running <br /> And Waiting Jobs
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={'recrawl'}>
            {(UrlParams.jobType == 'recrawl' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Recrawl</span><br />
                <a target="_blank" className="link-primary" href={recrawlKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={recrawlKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>

            }
          </TabPane>
          <TabPane tabId={'distributed_recrawl'}>
            {(UrlParams.jobType == 'distributed_recrawl' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Distributed Recrawl</span><br />
                <a target="_blank" className="link-primary" href={distributedRecrawlKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={distributedRecrawlKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="800" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>

            }
          </TabPane>
          <TabPane tabId={'feedcrawl'}>
            {(UrlParams.jobType == 'feedcrawl' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Feedcrawl</span><br />
                <a target="_blank" className="link-primary" href={feedcrawlKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={feedcrawlKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>
            }
          </TabPane>
          <TabPane tabId={'dependent_data_upload'}>
            {(UrlParams.jobType == 'dependent_data_upload' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Dependent Data Upload</span><br />
                <a target="_blank" className="link-primary" href={dependentDataUploadKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={dependentDataUploadKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>
            }
          </TabPane>
          <TabPane tabId={'total_running_and_waiting_jobs'}>
            {(UrlParams.jobType == 'total_running_and_waiting_jobs' || UrlParams.jobType == '*') ? <div className="panel-body">
              <center>
                <span className="fw-bold">Total Running And Waiting Jobs</span><br />
                <a target="_blank" className="link-primary" href={totalRunningAndWaitingJobsKibanaUrl(KIBANA_PLM_INTERNAL_URL)}>Click here to see below graph in kibana</a>
              </center>
              <iframe src={totalRunningAndWaitingJobsKibanaUrl(KIBANA_PLM_URL) + "&embed=true"} height="500" width="100%" className="border-0"></iframe>
            </div> :
              <center className="fw-bold mt-5">No Data Found...</center>
            }
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  </Container>
}

